import { IdentityCompressionStrategy } from './IdentityCompressionStrategy';
import type {
  CompressionConfig,
  CompressionDebugState,
  CompressionStrategy,
} from './types';

export function createCompressionStrategy(
  config: CompressionConfig
): CompressionStrategy {
  if (!config.enabled || config.strategy === 'identity') {
    return new IdentityCompressionStrategy();
  }

  return new IdentityCompressionStrategy();
}

export function getCompressionDebugState(
  config: CompressionConfig,
  strategy: CompressionStrategy,
  lastResult?: { originalSize: number; compressedSize: number } | null
): CompressionDebugState {
  return {
    enabled: config.enabled,
    strategy: strategy.name,
    lastOriginalSize: lastResult?.originalSize ?? null,
    lastCompressedSize: lastResult?.compressedSize ?? null,
  };
}

export type {
  CompressionConfig,
  CompressionDebugState,
  CompressionStrategy,
  CompressionResult,
} from './types';
export { IdentityCompressionStrategy } from './IdentityCompressionStrategy';
